let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kAWvw")).then(() => parcelRequire('1Cnkz'));